import { ImagePreview } from "@fawkes/ui";

import { useAuthImage } from "../../utils/authImage";

// jmix-8.2/8.4: a bearer-authenticated image. `path` is an API path the portal serves (animal photo /
// organization logo); `null` means "no image" (e.g. hasPhoto === false) → straight to the placeholder with
// no fetch. While loading and when absent (404) we render @fawkes/ui's ImagePreview placeholder — the
// Golden Rule: compose, never edit. The object-URL lifecycle (create/revoke) lives in useAuthImage.
export function AuthImage({
  path,
  alt,
  size,
  className,
}: {
  path: string | null;
  alt: string;
  size?: string;
  className?: string;
}) {
  const url = useAuthImage(path);
  return <ImagePreview src={url ?? null} alt={alt} size={size} className={className} />;
}
